import React, { ReactNode } from 'react'
import { GasPriceContext } from './context'
import { useDelayGasPrice } from './useDelayGasPrice'
import { useNetworkGasPrice } from './useNetworkGasPrice'
import { useSettings } from '../settings/context'
import { useGasPriceForEthMax } from './useGasPriceForEthMax'
import { getSuggestedMaxGasFee, getGasPriceFromFees } from '../../utils'

interface Props {
  children: ReactNode
}

export function GasPriceProvider({ children }: Props) {
  const delayGasPrice = useDelayGasPrice()
  const networkGasPrice = useNetworkGasPrice()
  const baseFee = networkGasPrice?.baseFee
  const { maxGasFeeForEthMax, maxGasTipForEthMax, setMaxGasFeeForEthMax } = useGasPriceForEthMax(baseFee)
  const { settings } = useSettings()

  const settingsGasTip = [networkGasPrice?.slow, networkGasPrice?.average, networkGasPrice?.fast][
    settings.gasPriceSpeed
  ]
  const settingsGasPrice = settingsGasTip && baseFee && getGasPriceFromFees(baseFee, settingsGasTip)

  const values = {
    delayGasPrice:
      delayGasPrice && settingsGasPrice && delayGasPrice.gt(settingsGasPrice) ? delayGasPrice : settingsGasPrice,
    networkGasPrice: settingsGasPrice,
    networkGasTip: settingsGasTip,
    fastNetworkGasTip: networkGasPrice?.fast,
    averageNetworkGasTip: networkGasPrice?.average,
    slowNetworkGasTip: networkGasPrice?.slow,
    baseFee,
    maxGasFee: settingsGasTip && baseFee && getSuggestedMaxGasFee(baseFee, settingsGasTip),
    maxGasFeeForEthMax,
    maxGasTipForEthMax,
    setMaxGasFeeForEthMax,
  }

  return <GasPriceContext.Provider value={values} children={children} />
}
